<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hs1XmZ/tc-custom/9781488013027.jpg?1726617345418" alt="This image is the cover for the book Fearless Gunfighter, The Kavanaughs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fearless Gunfighter, The Kavanaughs
      </h1>
      <p class="bookDescription body article font2">
        <b>As an FBI agent fights to save her sister from a killer, a courageous rodeo star could prove a lethal distraction . . .</b><br/><br/>Rodeo rider Tucker Lawrence lives for risk—even after seeing his best friend die in a rodeo accident. But there’s no chance in hell he’s going to let FBI agent Sydney Maxwell tackle treacherous Texas Hill Country alone to find her missing sister. Even if the pretty profiler is putting his guarded heart in danger . . .<br/><br/>With her sister in the hands of a serial killer, Sydney will break all the rules she has to. Tucker is as reckless as he is charming, but his trail savvy and courage are invaluable as they run her quarry to ground. Still, Sydney can’t afford to gamble that the irresistible passion flaring between them is anything but an adrenaline rush. Or that they’ll survive long enough for real love . . .<br/><br/><b>Praise for the Joanna Wayne</b><br/><br/>“Wayne creates intricate relationships and compellingly plotted suspense.” —<i>Romantic Times</i><br/><br/>“Joanna Wayne weaves together a romance and suspense with pulse-pounding results!” —<i>New York Times</i>–bestselling author Tess Gerritsen
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joanna Wayne
      </h2>
      
      <p class="authorDescription body article"><B>This courageous rodeo star is one lethal attraction&hellip;</B><BR /><BR /> Rodeo rider Tucker Lawrence lives for risk&mdash;even after seeing his best friend die in a rodeo accident. But there&rsquo;s no chance in hell he&rsquo;s going to let FBI agent Sydney Maxwell tackle treacherous Texas Hill Country alone to find her missing sister. Even if the pretty profiler is putting his guarded heart in danger&hellip;<BR /><BR /> With her sister in the hands of a serial killer, Sydney will break all the rules she has to. Tucker is as reckless as he is charming, but his trail savvy and courage are invaluable as they run her quarry to ground. Still, Sydney can&rsquo;t afford to gamble that the irresistible passion flaring between them is anything but an adrenaline rush. Or that they&rsquo;ll survive long enough for real love&hellip;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26843fb3